import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useTranslation } from "react-i18next";

import { download } from "../../../../components/ApplicantDocumentUpload/utils";

export function ProofOfAddressSummaryField({
  field,
}: {
  field: components["schemas"]["ProofOfAddressCheckField"];
}) {
  const { t } = useTranslation();

  return (
    <InnerContentItem
      label={t("Address document")}
      icon="download"
      onIconPress={() =>
        field.value && download(field.value.get_url, field.value.file_name)
      }
      testID="proof-of-address-address-document"
    >
      {field.value?.file_name ?? "-"}
    </InnerContentItem>
  );
}
